import { useI18n } from '../../i18n';

export const LOW_STOCK_THRESHOLD = 10;

export const getStockStatus = quantity => {
  const qty = Number(quantity) || 0;
  if (qty <= 0) return 'out';
  if (qty <= LOW_STOCK_THRESHOLD) return 'low';
  return 'ok';
};

const TONES = { ok: 'success', low: 'warning', out: 'danger' };
const LABELS = { ok: 'products.statusOk', low: 'products.statusLow', out: 'products.statusOut' };

export const StockBadge = ({ quantity }) => {
  const { t } = useI18n();
  const status = getStockStatus(quantity);
  return <span className={`wm-badge wm-badge--${TONES[status]}`}>{t(LABELS[status])}</span>;
};
